<template>
    <button
        v-tippy="t('editorAddRowBefore')"
        :class="[buttonState(editor.can().addRowBefore()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().addRowBefore()"
        @click="editor.chain().focus().addRowBefore().run()"
    >
        <MdiTableRowPlusBefore class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiTableRowPlusBefore from 'materialdesignicons-vue3/icons/MdiTableRowPlusBefore.js';

    defineExpose({
        name: 'AddTableRowBeforeButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
